import { O } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BuySellApproveDenyDialogComponent } from '@app/modules/time-off/buy-sell-approvals/components/buy-sell-approve-deny-dialog/buy-sell-approve-deny-dialog.component';

@Component({
  selector: 'app-buy-sell-approval-form',
  templateUrl: './buy-sell-approval-form.component.html',
  styleUrls: ['./buy-sell-approval-form.component.scss']
})
export class BuySellApprovalFormComponent implements OnInit {
  @Input() buySellApproval: any;
  @Input() buySellPlan: any;
  @Input() buySellPlanEmployee: any;
  @Input() selectedType: string;
  @Input() compensation: any;

  @Output() approvalUpdated = new EventEmitter<boolean>();

  constructor(
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {}

  openApproveDenyDialog(action: string) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      buySellApprovalId: this.buySellApproval.id,
      type: this.buySellPlan?.type,
      action: action,
      message:
        action === 'approve'
          ? `You are approving ${this.buySellApproval.employee.firstName} ${this.buySellApproval.employee.lastName}'s request to ${this.buySellApproval.buySell?.type?.name} ${this.buySellApproval.buySell?.hours} hour(s) from ${this.buySellApproval?.plan?.name}.`
          : `You are denying ${this.buySellApproval.employee.firstName} ${this.buySellApproval.employee.lastName}'s request to ${this.buySellApproval.buySell?.type?.name} ${this.buySellApproval.buySell?.hours} hour(s) from ${this.buySellApproval?.plan?.name}.`
    };

    const dialogRef = this.dialog.open(BuySellApproveDenyDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          // Handle successful approval/denial if needed
          this.approvalUpdated.emit(true);
        }
      }
    );
  }

}
